import { apiClient } from '@lib/api/client';
import type { Customer, CustomerListResponse, CustomerListParams } from '../types/customer.types';

/**
 * Customer Service
 * Handles customer-related API calls through the BFF
 */
export const customerService = {
  /**
   * Get paginated list of customers
   * Automatically filtered by the selected company in the backend
   */
  async getCustomers(params?: CustomerListParams): Promise<CustomerListResponse> {
    const queryParams = {
      page: params?.page || 1,
      limit: params?.limit || 10,
      name: params?.name,
      taxId: params?.taxId,
    };

    console.log('📡 getCustomers - Parámetros enviados:', queryParams);

    const response = await apiClient.get<CustomerListResponse>('/customers', {
      params: queryParams,
    });

    console.log('📡 getCustomers - Respuesta recibida:', {
      total: response.data.total,
      page: response.data.page,
      limit: response.data.limit,
      totalPages: response.data.totalPages,
      customersCount: response.data.customers.length,
    });

    return response.data;
  },

  /**
   * Get customer by ID
   */
  async getCustomerById(id: string): Promise<Customer> {
    const response = await apiClient.get<Customer>(`/customers/${id}`);
    return response.data;
  },

  /**
   * Create a new customer
   */
  async createCustomer(customer: Partial<Customer>): Promise<Customer> {
    const response = await apiClient.post<Customer>('/customers', customer);
    return response.data;
  },

  /**
   * Update an existing customer
   */
  async updateCustomer(id: string, customer: Partial<Customer>): Promise<Customer> {
    const response = await apiClient.put<Customer>(`/customers/${id}`, customer);
    return response.data;
  },

  /**
   * Delete a customer
   */
  async deleteCustomer(id: string): Promise<void> {
    await apiClient.delete(`/customers/${id}`);
  },

  /**
   * Verify RUC/DV with DGI
   */
  async verifyRucDV(ruc: string, dv: string, tipoRuc: string): Promise<{
    success: boolean;
    code: string;
    message: string;
    tipoRucCorregido?: boolean;
    data: {
      ruc: string;
      dv: string;
      nombre: string;
      tipoRuc: string;
      tipoRec: string;
      afiliadoSFE: string;
    } | null;
  }> {
    const response = await apiClient.post('/customers/verify-ruc', {
      ruc,
      dv,
      tipoRuc,
    });
    return response.data;
  },
  
   async downloadTemplate(): Promise<void> {
    const response = await apiClient.get('/customers/template', {
      responseType: 'blob',
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'plantilla_clientes.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  async importCustomers(file: File): Promise<{ success: boolean; imported: number; errors?: any[] }> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiClient.post('/customers/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return response.data;
  },
};
